<template lang="pug">
span
  v-dialog(v-model="isModalVisible" persistent lazy max-width="450px")
    v-card
      title-bar(dark) Sort {{ resource }}
      v-card-text
        v-layout(column wrap)
          span.mb-3.px-3 This list is sorted by priority, items at the top have higher priority than items at the bottom.
          v-flex.ordering
            sortable-list(
              v-model="sortedItems"
              lockAxis="y"
              axis="y"
              appendTo=".sortable-list"
              helperClass="dragging"
              @input="reorder"
            )
              sortable-item(v-for="(item, index) in sortedItems" :index="index" :key="index")
                span.text-truncate {{ item[labelField] }}
      v-card-actions.px-4.py-3
        v-spacer
        v-btn(@click="cancel" flat) Cancel
        v-btn(@click="save" color="primary") Apply
</template>

<script>
import Modal from '@/Core/mixins/modal';
import SortableList from '@/Core/components/sortable/SortableList';
import SortableItem from '@/Core/components/sortable/SortableItem';
import TitleBar from '@/Core/components/TitleBar';

export default {
  name: 'SortingModal',
  components: {
    SortableList,
    SortableItem,
    TitleBar,
  },
  mixins: [Modal],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    // the fields values must be a numeric field
    sortingField: {
      type: String,
      required: true,
    },
    labelField: {
      type: String,
      required: true,
    },
    resource: String,
  },
  data() {
    return {
      sortedItems: [],
    };
  },
  watch: {
    isModalVisible(val) {
      if (val) {
        const copyItems = this.value.map(item => Object.assign({}, item));
        this.sortedItems = copyItems.sort((a, b) =>
          a[this.sortingField] < b[this.sortingField] ? -1 : 1,
        );
      }
    },
  },
  methods: {
    reorder() {
      this.sortedItems.forEach((item, index) => (item[this.sortingField] = index + 1));
    },
    cancel() {
      this.modal_close();
      this.sortedItems = [];
    },
    save() {
      this.$emit('input', this.sortedItems);
      this.modal_close();
      this.sortedItems = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.ordering {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 300px;

  .sortable-list {
    padding: 0 1em;
    overflow-y: auto;

    .sortable-item,
    .dragging {
      display: flex;
      align-items: center;
      padding: 3px 5px;
      background-color: #eaf0f6;
      border: 1px solid #cbd6e2;
      border-radius: 2px;
      margin-bottom: 0.5em;
      cursor: move;
    }

    .dragging {
      opacity: 0.75;
    }
  }
}
</style>
